import * as React from 'react';
import { MutationFunc, compose, graphql } from 'react-apollo';
import { Loader, Button } from '../../modules/modules';
import { CompletePayment } from './CompletePayment';

export interface IAuthorizeNetButtonProps {
  btnCaption: string;
  disabled?: boolean;
  order: GQL.IOrder;
  payment?: GQL.IPayment;
  nextData?: string; // todo: fuj !!!
  createPayment: MutationFunc;
  setPaymentStatus?: MutationFunc;
  completePayment: MutationFunc;
  onRefetch: () => void;
}

interface IAuthorizeNetButtonState {
  gatewayUrl: string | null;
  token: string | undefined | null;
  detecting: boolean;
  // redirect: boolean;
}

class AuthorizeNetButton extends React.Component<IAuthorizeNetButtonProps, IAuthorizeNetButtonState> {

  public constructor(props: IAuthorizeNetButtonProps) {
    super(props);

    this.state = {
      gatewayUrl: null,
      token: null,
      detecting: false,
      // redirect: false,
    };
  }

  public async componentDidMount() {
    const { order, payment, nextData, completePayment } = this.props;
    
    if (this.props.nextData && payment && completePayment && !this.state.detecting) {
      this.setState({
        detecting: true,
      }, async () => {

        // vypadá to, že je to správný odkaz pro success url
        if (nextData === (payment.description as any).hash && this.props.setPaymentStatus) {

          // nastavím status platby jako předschválený
          await this.props.setPaymentStatus({
            variables: {
              paymentId: payment.id,
              status: 'pre-approved',
            }
          }).then((result) => {
            // akzualizace dat
            this.props.onRefetch();
          });
        }
      });
    }

    if (this.state.token === null && !nextData) {
      // vytvoření platby
      const createPaymentResult = await this.props.createPayment({
        variables: {
          orderNumber: order.orderNumber,
          language: order.language,
          paymentMethod: order.paymentMethod.id,
        }
      });
      // zpracování výsledku
      if (createPaymentResult && createPaymentResult.data && createPaymentResult.data.createPayment) {
        this.setState({
          gatewayUrl: createPaymentResult.data.createPayment.gatewayUrl,
          token: createPaymentResult.data.createPayment.token,
        });
      }
    }
  }

  public render() {
    const { /*order, */btnCaption, disabled } = this.props;
    // const { countryCode } = CountryService.GetInstance();

    // if (this.state.redirect === true) {
    //   return (
    //     <Redirect to={`/${countryCode}/order-finished/${order.orderNumber}/${order.id}/done`} push={true} />
    //   );
    // }

    if (this.state.token === null || this.state.gatewayUrl === null) {
      return (
        <Loader />
      );
    }

    return (
      <form
        method="post"
        action={this.state.gatewayUrl}
        onSubmit={() => disabled !== true}
        id="formAuthorizeNetTestPage"
        name="formAuthorizeNetTestPage"
      >
        <input type="hidden" id="redirectToken" name="token" value={this.state.token} />
        <Button type={'red btn--lg'} disabled={disabled}>
          {btnCaption}
        </Button>
      </form>
    );
  }
}

export default compose(
  graphql<any, any>(CompletePayment, {
    name: 'completePayment'
  })
)(AuthorizeNetButton);


// WEBPACK FOOTER //
// ./src/components/GatewayComponent/AuthorizeNetButton.tsx